exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-checkbox .custom-control-input:checked~.custom-control-label[data-v-24f8e07d]:after,.custom-checkbox .custom-control-label[data-v-24f8e07d]:before{margin-top:9px}label[data-v-24f8e07d]{display:block;width:100%}.custom-control-inline[data-v-24f8e07d]{display:block}.icon-menu[data-v-24f8e07d]{color:#ccc;color:#000}.handle[data-v-24f8e07d]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24f8e07d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/startpage/startpage-container.vue
// module id = 1571
// module chunks = 0